module.exports = __webpack_public_path__ + "static/media/magnet.4a75c124.svg";